_affirm_config = {
  public_api_key: "{YOUR_PUBLIC_API_KEY}",
  script: "https://cdn1.affirm.com/js/v2/affirm.js",
  locale: "en_CA",
  country_code: "CAN",
};

(function(m,g,n,d,a,e,h,c){var b=m[n]||{},k=document.createElement(e),p=document.getElementsByTagName(e)[0],l=function(a,b,c){return function(){a[b]._.push([c,arguments])}};b[d]=l(b,d,"set");var f=b[d];b[a]={};b[a]._=[];f._=[];b._=[];b[a][h]=l(b,a,h);b[c]=function(){b._.push([h,arguments])};a=0;for(c="set add save post open empty reset on off trigger ready setProduct".split(" ");a<c.length;a++)f[c[a]]=l(b,d,c[a]);a=0;for(c=["get","token","url","items"];a<c.length;a++)f[c[a]]=function(){};k.async=
!0;k.src=g[e];p.parentNode.insertBefore(k,p);delete g[e];f(g);m[n]=b})(window,_affirm_config,"affirm","checkout","ui","script","ready","jsReady");


setTimeout(() => {
  let _shopify_locale = Shopify.locale;
  let _shopify_country = Shopify.country;
  let _affirm_locale;
  let _affirm_country;
  
  if (_shopify_country === 'US') {
      _affirm_country = 'USA';
      _affirm_locale = 'en_US';
  } else if (_shopify_country === 'CA') {
      _affirm_country = 'CAN';
      _affirm_locale = (_shopify_locale === 'fr' ?  'fr' : 'en') + '_' + _shopify_country;
  } else {
      _affirm_country = 'USA';
      _affirm_locale = 'en_US'
  }
  
  _affirm_config = {
      public_api_key: "{YOUR_PUBLIC_API_KEY}",
      script: "https://cdn1.affirm.com/js/v2/affirm.js",
      locale: _affirm_locale,
      country_code: _affirm_country,
  };
  
  (function(m,g,n,d,a,e,h,c){var b=m[n]||{},k=document.createElement(e),p=document.getElementsByTagName(e)[0],l=function(a,b,c){return function(){a[b]._.push([c,arguments])}};b[d]=l(b,d,"set");var f=b[d];b[a]={};b[a]._=[];f._=[];b._=[];b[a][h]=l(b,a,h);b[c]=function(){b._.push([h,arguments])};a=0;for(c="set add save post open empty reset on off trigger ready setProduct".split(" ");a<c.length;a++)f[c[a]]=l(b,d,c[a]);a=0;for(c=["get","token","url","items"];a<c.length;a++)f[c[a]]=function(){};k.async=
    !0;k.src=g[e];p.parentNode.insertBefore(k,p);delete g[e];f(g);m[n]=b})(window,_affirm_config,"affirm","checkout","ui","script","ready","jsReady");
  });
  